/**
 * Filtre en segments visibles en permanence.
 *
 * Remplace une liste déroulante partout où l'utilisateur doit voir d'un coup
 * d'œil les catégories disponibles. Une liste déroulante oblige à l'ouvrir pour
 * découvrir ce qu'elle contient : c'est ainsi qu'un doublon de typologie est
 * parti en production sans que personne puisse le voir.
 *
 * Tous les segments sont rendus, **y compris ceux dont le compteur vaut zéro**.
 * Une catégorie qui disparaît faute d'élément ne peut ni être découverte, ni
 * servir à classer quoi que ce soit.
 */
export default function SegmentedFilter({
  value,
  onChange,
  options,
  counts,
  ariaLabel,
  testId,
}) {
  const afficheCompteurs = Boolean(counts);

  return (
    <div className="flex flex-wrap gap-2" role="tablist" aria-label={ariaLabel} data-testid={`${testId}-bar`}>
      {options.map(({ value: valeur, label }) => {
        const actif = value === valeur;
        return (
          <button
            key={valeur}
            type="button"
            role="tab"
            aria-selected={actif}
            onClick={() => onChange(valeur)}
            data-testid={`${testId}-tab-${valeur}`}
            className={
              "inline-flex items-center gap-2 px-3.5 h-9 rounded-xl text-sm font-medium " +
              "border transition-all " +
              (actif
                ? "bg-gradient-to-br from-blue-700 to-slate-900 text-white border-transparent shadow-sm"
                : "bg-white text-slate-700 border-slate-200 hover:border-blue-300 hover:bg-blue-50/40")
            }
          >
            <span>{label}</span>
            {afficheCompteurs ? (
              <span
                data-testid={`${testId}-count-${valeur}`}
                className={
                  "inline-flex items-center justify-center min-w-[1.5rem] h-5 px-1.5 " +
                  "rounded-full text-xs font-semibold tabular-nums " +
                  (actif ? "bg-white/20 text-white" : "bg-slate-100 text-slate-600")
                }
              >
                {counts[valeur] ?? 0}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
